import React from 'react'
import * as closeProjectOfficerType from './closeProjectOfficerType'

const useCloseProjectOfficer = (props: closeProjectOfficerType.UseCloseProjectOfficerFormType) => {
    const {} = props

    React.useEffect(() => {}, [])

    return {}
}

export default useCloseProjectOfficer
